import StripeElementForm from './StripeElementForm';

export default StripeElementForm;
